import { useEffect, useState } from "react";
import { Avatar, Button, LevelBadge } from "@jaiho/ui";
import type { PublicPlayerSummaryDTO } from "@jaiho/shared";
import { getPlayerSummary } from "../api/endpoints";
import "./Sheet.css";
import "./PlayerProfileSheet.css";

export function PlayerProfileSheet({ userId, onClose }: { userId: string; onClose: () => void }) {
  const [summary, setSummary] = useState<PublicPlayerSummaryDTO | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    getPlayerSummary(userId)
      .then(setSummary)
      .catch(() => setFailed(true));
  }, [userId]);

  return (
    <div className="jaiho-sheet-backdrop" onClick={onClose}>
      <div className="jaiho-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="jaiho-sheet__handle" />

        {failed && <div className="jaiho-player-sheet__error">Couldn't load this player.</div>}

        {!failed && !summary && <div className="jaiho-skeleton jaiho-player-sheet__skeleton" />}

        {summary && (
          <div className="jaiho-player-sheet">
            <div className="jaiho-player-sheet__avatar-wrap">
              <Avatar name={summary.displayName} src={summary.avatarUrl} size={72} />
              <LevelBadge level={summary.level} />
            </div>
            <div className="jaiho-player-sheet__name">{summary.displayName}</div>
            <div className="jaiho-player-sheet__meta">
              Joined{" "}
              {new Date(summary.memberSince).toLocaleDateString("en-IN", { year: "numeric", month: "short" })}
              {" · "}
              {summary.achievementsUnlockedCount} achievement{summary.achievementsUnlockedCount === 1 ? "" : "s"}
            </div>
          </div>
        )}

        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}
